import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

/**
 *
 * @param {int} sedeId
 * @returns {Promise<object>}
 */
export const selectLugaresPorSede = async (sedeId) => {
    try {
        const resp = await axios.get(
            `${API_URL}/lugares/select/${sedeId}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
